var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{ref:`component-toolbar-${_vm.component}`,tag:"component",class:'text-' +
    _vm.textColor +
    ' bg-' +
    _vm.bgColor +
    (_vm.divider && _vm.component === 'QHeader'
      ? ' d-bottom-border'
      : _vm.divider && _vm.component === 'QFooter'
      ? ' d-top-border'
      : '')},[_c('q-toolbar',{class:_vm.component === 'QFooter' ? 'toolbar' : ''},[_c('div',{staticClass:"row justify-between items-center content-center full-width"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }